<template>
  <v-app id="app" @click='appClick' :class="[$root.isRTL ? 'RLT' : '']">
    <transition name="slide-top">
      <router-view class="child-view"></router-view>
    </transition>
  </v-app>
</template>

<script>

export default {
    name: 'app',
    data() {
      return {
      }
    }, 
    methods: {
      appClick(event) {
        var data = event.target.getAttribute("data");
        if (data != 'btnNew') {
          this.$root.btnNew = false;
        }
      }
    }
}
</script>

<style>
  html, body {
    width: 100%;
    height: 100%;
    overflow: hidden;
    /*overflow: auto;*/
    /*overflow-y: auto;*/
    -webkit-overflow-scrolling: touch;
  }
  a:link {
    text-decoration: none;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    width: 100%;
    height: 100%;
  }

  .child-view {
    position: absolute;
    transition: all .5s cubic-bezier(.5,0,.1,1);
  }

  .slide-left-enter, .slide-right-leave-active {
    opacity: 0;
    -webkit-transform: translate(100%, 0);
    transform: translate(100%, 0);
  }

  .slide-left-leave-active, .slide-right-enter {
    opacity: 0;
    -webkit-transform: translate(-100%, 0);
    transform: translate(-100%, 0);
  }

  .slide-top-enter, .slide-top-leave-active {
    opacity: 0;
    -webkit-transform: translate(100%, 0);
    transform: translate(100%, 0);
  }

  .slide-top-leave-active, .slide-top-enter {
    opacity: 0;
    -webkit-transform: translate(-100%, 0);
    transform: translate(-100%, 0);
  }

  .btnPopupYes {
    border: 1px solid green;
    background-color: transparent;
    color: green;
    border-radius: 3px;
    height: 30px;
    width: 100%;
    max-width: 130px;
  }
  btnPopupYes:hover {
    background-color: green;
    color: #fff;
  }

  .btnPopupNo {
    border: 1px solid red;
    background-color: transparent;
    color: red;
    border-radius: 3px;
    height: 30px;
    width: 100%;
    max-width: 130px;
  }
  btnPopupNo:hover {
    background-color: red;
    color: #fff;
  }

  .overlay {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.4);
    -webkit-transition: .3s cubic-bezier(.25,.8,.25,1);
    transition: .3s cubic-bezier(.25,.8,.25,1);
    top: 0;
    left: 0;
    -webkit-filter: blur(10%);
    filter: blur(10%);
    pointer-events: none !important;
    z-index: 1000;
  }
  .dialog__content {
    z-index: 20000 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    /* bring your own prefixes */
    transform: translate(-50%, -50%);
  }
</style>



// WEBPACK FOOTER //
// App.vue?9ef8e53e